import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ExternalLinkService {
  async open(url: string, target: '_blank' | '_self' = '_blank'): Promise<void> {
    if (typeof window === 'undefined') return;
    // Nothing may be awaited above this line: window.open has to be reached
    // synchronously from the user gesture or iOS blocks it. When it is blocked
    // (Safari, and installed PWAs in standalone mode) it returns null rather than
    // throwing, so fall back to navigating the current tab.
    const opened = window.open(url, target);
    if (!opened) {
      window.location.href = url;
    }
  }
}
